export const LOAD_TEMPLATE_OPTIONS_INTO_STORE =
  '@@NOTIFICATION_TEMPLATES_LOAD_TEMPLATE_OPTIONS_INTO_STORE';
export const LOAD_TEMPLATE_OPTIONS_INTO_STORE_BY_ID =
  '@@NOTIFICATION_TEMPLATES_LOAD_TEMPLATE_OPTIONS_INTO_STORE_BY_ID';
export const LOAD_NOTIFICATION_TEMPLATES_INTO_STORE =
  '@@NOTIFICATION_TEMPLATES_LOAD_NOTIFICATION_TEMPLATES_INTO_STORE';
export const GET_ALL_NOTIFICATIONS =
  '@@NOTIFICATION_TEMPLATES_GET_ALL_NOTIFICATIONS';
export const SAVE_NOTIFICATION_INFO_TO_STORE =
  '@@NOTIFICATION_TEMPLATES_SAVE_NOTIFICATION_INFO_TO_STORE';
export const CREATE_NOTIFICATION_TEMPLATE =
  '@@NOTIFICATION_TEMPLATES_CREATE_NOTIFICATION_TEMPLATE';
export const UPDATE_NOTIFICATION_TEMPLATE =
  '@@NOTIFICATION_TEMPLATES_UPDATE_NOTIFICATION_TEMPLATE';
export const TOGGLE_IS_PROCESSING =
  '@@NOTIFICATION_TEMPLATES_TOGGLE_IS_PROCESSING';
export const GET_EXISTING_TEMPLATE_TYPES =
  '@@NOTIFICATION_TEMPLATES_GET_EXISTING_TEMPLATE_TYPES';
export const GET_EXISTING_TEMPLATE_HEADERS =
  '@@NOTIFICATION_TEMPLATES_GET_EXISTING_TEMPLATE_HEADERS';
export const GET_EXISTING_TEMPLATE_SIGNATURES =
  '@@NOTIFICATION_TEMPLATES_GET_EXISTING_TEMPLATE_SIGNATURES';
export const SAVE_TOKEN_INFO_TO_STORE =
  '@@NOTIFICATION_TEMPLATES_SAVE_TOKEN_INFO_TO_STORE';
export const LOAD_TEMPLATES_BY_OPTION =
  '@@NOTIFICATION_TEMPLATES_LOAD_TEMPLATES_BY_OPTION';
export const GET_NOTIFICATION_REPORT_INFO =
  '@@NOTIFICATION_TEMPLATES_GET_NOTIFICATION_REPORT_INFO';
